import * as React from 'react';

import {Box, Typography} from "@mui/material";

import {computeN, formatNumber, formatPercentage, getTrendIcon, getWidth, tours} from "../../../Utils";

export default function EvolutionTour1Tour2({title, data, maxInscrit, percentVisible}) {

    function getTrendBaBare(trendPerc, color, b) {
        let trend = "";
        if (trendPerc > 0) {
            trend = "Augmentation au " + tours["t2"]
        } else if (trendPerc < 0) {
            trend = "Diminution au " + tours["t2"]
        }

        if (trend === "") {
            return (
                <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                </Box>)
        }
        /* return (
             <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                 &nbsp;{getTrendIcon(trendPerc, b)}
                 <Typography variant={"body"} sx={{color: color}}>
                     &nbsp;({formatPercentage(trendPerc)})
                 </Typography>
                 <Typography>
                     &nbsp;{trend}
                 </Typography>
             </Box>
         );*/
        return (
            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                &nbsp;{getTrendIcon(trendPerc, b)}
                <Typography variant={"body"} sx={{color: color}}>
                    &nbsp;{formatPercentage(trendPerc)}
                </Typography>

            </Box>
        );
    }

    return (
        <Box sx={{width: '100%', display: "flex", flexDirection: "column",}}>
            <Typography variant={"h6"}
                        sx={{
                            color: "#000",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "32px"
                        }}>{title}</Typography>

            <Box sx={{width: '100%', display: "flex", flexDirection: "row", mt: 2, alignItems: "center"}}>
                <Box sx={{width: 900}}>
                    {data && Object.keys(data).sort().slice(-computeN(data)).reverse().map((year, k) => {
                        return (
                            <Box
                                sx={{width: '100%', display: "flex", flexDirection: "row", mb: 1, alignItems: "center"}}
                                key={k}>
                                <Box sx={{
                                    display: "flex",
                                    height: "71px",
                                    padding: "5px 10px",
                                    alignItems: "center",
                                    alignSelf: "stretch"
                                }}>
                                    <Typography sx={{
                                        color: "#666",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "24px"

                                    }}>{year}</Typography>
                                </Box>
                                <Box sx={{width: "100%"}}>
                                    <Box sx={{display: "flex"}}>
                                        <Box sx={{
                                            backgroundColor: "#E8EDDF",
                                            width: getWidth(data[year]["t1"].nb, maxInscrit),
                                            mr: 1,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            height: 30,
                                            color: "#000",
                                            borderTopRightRadius: 15,
                                            borderBottomRightRadius: 15
                                        }}>
                                            <Box sx={{
                                                pr: 1,
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: 'center'
                                            }}>
                                                <Typography sx={{
                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 700,
                                                    lineHeight: "24px",

                                                }}>
                                                    {formatNumber(data[year]["t1"].nb)}
                                                </Typography>
                                                {percentVisible && <Typography sx={{

                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                                    &nbsp;({formatPercentage(data[year]["t1"].perc)})
                                                </Typography>}
                                            </Box>
                                        </Box>

                                        {data[year]["t1"].trendPerc &&
                                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                                                &nbsp;({getTrendIcon(data[year]["t1"].trendPerc, true)}
                                                <Typography variant={"body"} sx={{color: data[year]["t1"].color}}>
                                                    &nbsp;{formatPercentage(data[year]["t1"].trendPerc)}
                                                </Typography>
                                            </Box>
                                        }

                                    </Box>
                                    {data[year]["t2"] && <Box sx={{display: "flex"}}>
                                        <Box sx={{
                                            backgroundColor: "#f5cb5c",
                                            width: getWidth(data[year]["t2"].nb, maxInscrit),
                                            mr: 1,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            height: 30,
                                            borderTopRightRadius: 15,
                                            borderBottomRightRadius: 15, color: "#000"
                                        }}>
                                            <Box sx={{
                                                pr: 1,
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: 'center'
                                            }}>
                                                <Typography sx={{
                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 700,
                                                    lineHeight: "24px",

                                                }}>
                                                    {formatNumber(data[year]["t2"].nb)}
                                                </Typography>
                                                {percentVisible && <Typography sx={{

                                                    color: "#000",
                                                    fontSize: "16px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "24px"
                                                }}>
                                                    &nbsp;({formatPercentage(data[year]["t2"].perc)})
                                                </Typography>}
                                            </Box>
                                        </Box>
                                        {data[year]["t2"].perc &&
                                            <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>

                                            </Box>}
                                        {getTrendBaBare(data[year]["t2"].trendPerc, data[year]["t2"].color, true)}
                                    </Box>}
                                </Box>
                            </Box>)

                    })}
                </Box>
                <Box sx={{width: 250, display: "flex", flexDirection: "row", height: "100%"}}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: 'flex-start',
                        height: 80,
                        backgroundColor: "#F7F7F7",
                        borderRadius: 5,
                        pl: 5,
                        pr: 5,
                        justifyContent: "center"
                    }}>
                        <Box sx={{display: "flex", alignItems: "center", height: 30}}>
                            <Box sx={{width: 20, height: 20, backgroundColor: "#e8eddf", mr: 1, color: "#000"}}></Box>
                            <Typography
                                sx={{
                                fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                            }}>{tours.t1}</Typography>
                        </Box>
                        <Box sx={{display: "flex", alignItems: "center", height: 30}}>
                            <Box sx={{width: 20, height: 20, backgroundColor: "#f5cb5c", mr: 1, color: "#000"}}></Box>
                            <Typography
                                sx={{
                                    fontSize: {md: "10px", lg: "12px", xl: "16px"},
                                    lineHeight: {md: "10px", lg: "12px", xl: "16px"}
                                }}
                            >{tours.t2}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>


        </Box>
    );

}


